import type { Plugin } from '../registry';

export enum LogType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export interface LogEntry {
  plugin: Plugin | string;
  message: string;
  type: LogType;
  time: number;
}

export interface ProgressEntry {
  plugin: Plugin | string;
  value: number;
  message?: string;
  time: number;
}
